import styled from 'styled-components';
import { AppIcons } from '../assets/images/Icons';
import { bodyFontStyle } from './Typography';

export const TickList = styled.ul`
  text-align: left;
  list-style-image: url('${AppIcons.tickListIcon}');
  padding-top: ${({ theme }) => theme.spacing._6px};

  li {
    padding-left: ${({ theme }) => theme.spacing._6px};
    ${bodyFontStyle}
  }
`;
